module.exports = __webpack_public_path__ + "img/web_08.831c28f5.png";